import React from 'react';
import Component from '@vfuk/core-progress-bar';
const ProgressBar = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default ProgressBar;
